import { Tooltip } from 'ant-design-vue'
import { checkApply } from '~/api'
import { USER_LEVEL_KEY } from '~/api/interface'
import { showContact } from '~/hooks/useModal/modals/contact'
import { useConfirm } from '~/hooks/useModal/modals/confirm'
import { ORDER_STATUS } from '~/constants/apply'
import { PageKey } from '~/constants/page'

export const useTaste = async () => {
  const { $t } = useNuxtApp()

  const canApply = ref(false)
  const userInfo = useUserInfo()
  const accountList = useAccountList()
  const info: any = userInfo.value

  // 体验版账号点击
  const { code, data } = await checkApply({ autoErrorHandle: false })
  // code !== 0 没有data 或者 未申请过但活动已过期
  if (code !== 0 || !data || (!data?.fill_data && !data?.activity_status)) {
    message.error($t('shi-yong-mingeyi-da-shang-xian'))
    return canApply
  }
  // 非体验版账号点击
  if (![USER_LEVEL_KEY.TASTE].includes(Number(info.rights_type))) {
    const taste = accountList.value.find(
      (item) => Number(item.rights_type) === USER_LEVEL_KEY.TASTE
    )
    if (taste) {
      useConfirm({
        title: $t('zhang-hao-shen-qing-xian-zhi'),
        icon: true,
        cancel: false,
        description: h('div', { class: '-mx-[20px]' }, [
          $t('jin-zhi-chi-ti-yan-ban-zhang-hao-jin-hang-shen-qing-shi-fou'),
          h(
            Tooltip,
            {
              color: 'white',
              placement: 'bottom',
              overlayClassName: 'x-title-tip',
            },
            {
              title: () =>
                h(
                  'div',
                  {
                    class: 'flex-y-center cursor-pointer gap-[4px]',
                  },
                  [
                    h('img', {
                      src: taste.logo_url,
                      class: 'w-[16px] h-[16px] rounded-[50%]',
                    }),
                    h('span', { class: 'text-font-1' }, taste.name),
                  ]
                ),
              default: () =>
                h(
                  'a',
                  {
                    class: 'text-primary cursor-pointer',
                    onClick: () => {
                      const showAccountType = useAccountType()
                      showAccountType.value = 'select'
                      // switchAccount(taste.user_id)
                      Modal.destroyAll()
                    },
                  },
                  $t('qie-huan-ti-yan-ban-zhang-hao')
                ),
            }
          ),
          $t('ru-xu-shen-qing-tuan-dui-shi-yong-zhang-hao-qing'),
          h(
            'a',
            {
              class: 'text-primary cursor-pointer',
              onClick: () => {
                Modal.destroyAll()
                setTimeout(() => showContact(), 100)
              },
            },
            $t('lian-xi-wo-men')
          ),
        ]),
        okText: $t('wo-zhi-dao-le'),
      })

      return canApply
    }
    message.info(
      h('div', null, [
        $t(
          'jin-zhi-chi-ge-ren-ti-yan-ban-zhang-hao-jin-hang-shen-qing-dang-qian-zhang-hao-bu-zhi-chi-shen-qing-shi-yong-ru-xu-shen-qing-tuan-dui-shi-yong-zhang-hao-qing'
        ),
        h(
          'a',
          {
            class: 'text-primary cursor-pointer',
            onClick: () => {
              message.destroy()
              showContact()
            },
          },
          $t('lian-xi-wo-men')
        ),
      ])
    )
    return canApply
  }
  const { index, fill_data, activity_status } = data!
  // 没有申请过，且活动有效
  if (!fill_data && activity_status) {
    canApply.value = true
    return canApply
  }
  if (index > 0) {
    message.info(
      $t(
        'dang-qian-shi-yongedu-yi-man-yi-wei-nin-zi-dong-pai-dui-deng-hou-wei-yu-index-wei-cheng-gong-hou-quan-yi-hui-zi-dong-fa-fang-bing-tong-zhi-nin',
        [index]
      )
    )
    return canApply
  }
  const router = useRouter()
  switch (fill_data.order_status) {
    case ORDER_STATUS.EFFECT:
      // 权益生效中
      useConfirm({
        title: $t('quan-yi-sheng-xiao-zhong'),
        icon: 'success',
        cancel: false,
        description: h('div', { class: '' }, [
          $t('nin-de-shi-yong-quan-yi-sheng-xiao-zhong'),
          h('br'),
          $t('ru-xu-huo-qu-geng-duo-quan-yi-qing'),
          h(
            'a',
            {
              class: 'text-primary cursor-pointer',
              onClick: () => {
                Modal.destroyAll()
                router.push({ name: PageKey.SUBSCRIBE })
              },
            },
            $t('fu-fei-ding-yue')
          ),
          $t('jin-hang-shi-yong'),
        ]),
        okText: $t('wo-zhi-dao-le'),
      })
      break
    case ORDER_STATUS.EXPIRED:
      // 权益已过期
      useConfirm({
        title: $t('qing-wu-zhong-fu-shen-qing'),
        icon: true,
        cancel: false,
        description: h('div', null, [
          $t('nin-yi-shen-qing-guo-shi-yong-qing'),
          h(
            'a',
            {
              class: 'text-primary cursor-pointer',
              onClick: () => {
                Modal.destroyAll()
                router.push({ name: PageKey.SUBSCRIBE })
              },
            },
            $t('fu-fei-ding-yue')
          ),
          "$t('jin-hang-shi-yong')，",
          h('br'),
          $t('ru-you-qi-ta-wen-ti-qing'),
          h(
            'a',
            {
              class: 'text-primary cursor-pointer',
              onClick: () => {
                Modal.destroyAll()
                openCustomerService()
              },
            },
            $t('lian-xi-ke-fu')
          ),
        ]),
        okText: $t('wo-zhi-dao-le'),
      })
      break
    default:
      break
  }

  return canApply
}
